// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design'
import './index.less'
// import 'view-design/dist/styles/iview.css'
Vue.use(ViewUI)
import './views/main.css'
import store from './store'
import LocalStorage from './libs/LocalStorageUtils'

Vue.config.productionTip = false
Vue.prototype.$localStorage = LocalStorage

router.beforeEach((to, from, next) => {
  if(window.localStorage.getItem("loginData") != null && store.state.user.login === false){
    let user_data = JSON.parse(window.localStorage.getItem("loginData"))
    if(user_data.session_id){
      store.commit('setLoginData',user_data)
    }
  }
  if ((to.path !== '/login') && store.state.user.login === false) {
    next({
      path: '/login',
    })
  }else {
    ViewUI.LoadingBar.start()
    next()
  }
})

router.afterEach(transition => {
  ViewUI.LoadingBar.finish()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js